<template>
  <div class="box">
    <div class="row">
      <div class="col-md-12 m-3">
        <h3>Record a transaction</h3>
      </div>
    </div>
    <hr/>
    <div class="row">
      <div class="col-md-12">
        <form class="form wrap form--inline" v-on:submit.prevent="savePayment">
          <div>
            <label for="payment_method">Payment method</label>
            <v-select
              v-model="newPayment.payment_method"
              :options="paymentOptions"
              id="payment_method"
              label="name"
              index="slug"
            ></v-select>
          </div>
    
          <div v-if="newPayment.payment_method != 'ecommpay'">
            <label for="transaction_id">Transaction ID</label>
            <input
              id="transaction_id"
              type="text"
              v-model="newPayment.transaction_id"
            />
          </div>
    
          <div>
            <label for="payment_amount">Payment amount</label>
            <input
              id="payment_amount"
              type="number"
              step="0.01"
              v-model="newPayment.payment_amount"
            />
          </div>
    
          <button v-if="this.getLoadStatus" type="submit" class="button" disabled>
            <span>Recording payment...</span>
          </button>
    
          <button v-else type="submit" class="button">
            <span>Record payment</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BookingPayment",
  props: {
    bookingID: Number
  },
  data() {
    return {
      newPayment: {
        holiday_booking_id: this.bookingID,
        paymentCompleted: false
      },
      paymentOptions: [
        {
          id: 1,
          name: "Ecommpay (Card)",
          slug: "ecommpay"
        },
        {
          id: 2,
          name: "Stripe",
          slug: "stripe"
        },
        {
          id: 3,
          name: "Travelink",
          slug: "travelink"
        },
        {
          id: 4,
          name: "Cheque",
          slug: "cheque"
        },
        {
          id: 5,
          name: "BACS",
          slug: "bacs"
        },
        {
          id: 6,
          name: "Cash",
          slug: "cash"
        },
        {
          id: 7,
          name: "Ecommpay Refund",
          slug: "ecommpay-refund"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getLoadStatus"])
  },
  methods: {
    savePayment() {
      this.$store.dispatch("setLoadStatus");
      fetch(this.$api + "payments", {
        method: "POST",
        body: JSON.stringify(this.newPayment),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: localStorage.getItem("token")
        }
      })
        .then(res => res.json())
        .then(response => {
          
          if (response.success || response.status) {

            if (this.newPayment.payment_method != "ecommpay") {
              this.$notify({
                type: "success",
                title: response.message
              });
              this.$store.dispatch("setLoadStatus");
              this.$emit("get-booking");
              return
            }

            const self = this;
            const ecomObject = {
              project_id: response.data.project_id,
              interface_type: response.data.interface_type,
              payment_id: response.data.payment_id,
              payment_amount: response.data.payment_amount,
              payment_currency: response.data.payment_currency,
              payment_description: response.data.payment_description,
              customer_id: response.data.customer_id,
              payment_extra_param: response.data.payment_extra_param,
              merchant_return_url: response.data.merchant_return_url,
              moto_type: response.data.moto_type,
              signature: response.data.signature,
              booking_info : response.data.extra_details_for_booking.booking_info
            }

            if ('customer_email' in response.data) {
              ecomObject['customer_email'] = response.data.customer_email
            }

            EPayWidget.run({
              ...ecomObject,
              onPaymentSuccess: function() {
                console.log("onPaymentSuccess");
                self.paymentCompleted = true;
                setTimeout(() => {
                  self.$emit("get-booking");
                  this.closePopup();
                }, 30000);
              },
              onExit: function() {
                console.log("onExit");
                if (self.paymentCompleted) {
                  self.$emit("get-booking");
                }
              }
            });
            
          } else {
            this.$notify({
              type: "error",
              title: response.message
            });
          }
          this.$store.dispatch("setLoadStatus");
        });
    }
  }
};
</script>
